import type { ApiView } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type ViewLoadedEvent = AvvirEvent<typeof VIEW_LOADED, ApiView>

const viewLoaded = (view: ApiView): ViewLoadedEvent => ({
  type: VIEW_LOADED,
  payload: view
});

export const VIEW_LOADED = "view_loaded";

export default viewLoaded;
